import suiteService from 'qreventos-suite/services';

class SuiteConfig {
    evento:number = 884;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = 'e8755c92-a445-4550-8a7c-86d16e8be160-884';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  
    }
}

export default new SuiteConfig();
